import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import Home from '../views/Home.vue';
import DevicesFilter from '../components/devices/DevicesFilter';
import Apiusers from '../components/apiuse/Apiusers';
import Newuser from "../components/apiuse/Newuser";
import UserInfo from '../components/apiuse/UserInfo';
import Apidashboard from '../components/apiuse/Dashboard';
import Login from '../components/Login';
import Customers from '../components/devices/Customers'
import Devices from '../components/devices/Devices';
import Onclick from '@/components/devices/Onclick';
import CustInfo from '../components/devices/CustInfo';
import Reports from '../components/devices/Reports';
import UpdateInfo from '../components/devices/updateInfo';
import Updatelimit from '../components/apiuse/Updatelimit';
import addDevice from '../components/devices/crud operations/addDevice';

Vue.use(VueRouter)

const isSuperUser = (to, from, next) => {
  let roleId = parseInt(JSON.parse(localStorage.getItem('user')).roleId);
  if (roleId === 3) {
    next();
    return;
  }
  next('/home')
}
const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next('/home');
};

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/search',
    name: 'DevicesFilter',
    component: DevicesFilter,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/cust',
    name: 'Customers',
    component: Customers,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/apiusers',
    name: 'Apiusers',
    component: Apiusers
  },
  {
    path: '/nusers',
    name: 'Newuser',
    component: Newuser
  },
  {
    path: '/apidb',
    name: 'Apidashboard',
    component: Apidashboard
  },
  {
    path: '/updateInfo',
    name: 'updateInfo',
    component: UpdateInfo,
    beforeEnter: ifAuthenticated && isSuperUser,
  },
  {
    path: '/devices',
    name: 'Devices',
    component: Devices,
  },
  {
    path: '/updatelimit',
    name: 'Updatelimit',
    component: Updatelimit,
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
  },
  {
    path: '/custInfo/:company/:custId',
    name: 'CustInfo',
    component: CustInfo,
  },
  {
    path: '/device/:deviceId/info',
    name: 'Onclick',
    component: Onclick,
    beforeEnter: ifAuthenticated,

  },
  {
    path: '/user/:userId/info',
    name: 'UserInfo',
    component: UserInfo,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/updateDevice/:deviceId',
    name: 'addDevice',
    component: addDevice,
    beforeEnter: ifAuthenticated,
  },
  { path: '*', component: Login },
]

const router = new VueRouter({
  routes,
})

export default router
